export default {
    GET_COMPLAINT_ERROR_SUCCESS: (state, data) => {
        state.errors = data
    },
}
